import { motion } from "framer-motion";
import { CreditCard, Shield, Truck } from "lucide-react";

interface PaymentBadgeProps {
  variant?: "compact" | "full";
}

export const PaymentBadge = ({ variant = "compact" }: PaymentBadgeProps) => {
  if (variant === "compact") {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground"
      >
        <CreditCard className="h-3.5 md:h-4 w-3.5 md:w-4" />
        <span>Pay in 3 interest-free installments</span>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="grid grid-cols-1 sm:grid-cols-3 gap-3"
    >
      <div className="flex items-center gap-2 px-3 py-2 bg-secondary/50 rounded-lg">
        <CreditCard className="h-4 w-4 text-primary flex-shrink-0" />
        <span className="text-xs font-medium">Pay in 3 installments</span>
      </div>
      <div className="flex items-center gap-2 px-3 py-2 bg-secondary/50 rounded-lg">
        <Shield className="h-4 w-4 text-green-600 flex-shrink-0" />
        <span className="text-xs font-medium">30-day money-back</span>
      </div>
      <div className="flex items-center gap-2 px-3 py-2 bg-secondary/50 rounded-lg">
        <Truck className="h-4 w-4 text-blue-600 flex-shrink-0" />
        <span className="text-xs font-medium">Free shipping over $50</span>
      </div>
    </motion.div>
  );
};
